module.exports = __webpack_public_path__ + "static/media/logo_header_nhidonghcm.92920c27.gif";